import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import { compactNumber } from "../../screens/dashboard/DashboardCard";

const BarChatDesktop = ({ label, online, inStore, currency }) => {
  console.log(label, online, inStore, "bar chart data");

  const isMobile = window.innerWidth <= 568;

  const yValue = [...online, ...inStore].map((val) => Number(val) || 0);
  const maxY = Math.max(0, ...yValue);
  const stepSize = maxY === 0 ? 10 : Math.ceil(maxY / 50);

  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 16,
        },
        display: false,
      },
      title: {
        display: false,
        text: "Amount of Product Sold",
      },
      tooltip: {
        callbacks: {
          // show full value in tooltip (not compact)
          label: (ctx) => `${ctx.dataset.label.trim()}: ${compactNumber(ctx.parsed.y)}`,
        },
      },
    },
    scales: {
      y: {
        ticks: {
          // compact labels on the axis
          callback: (value) => compactNumber(value),
          stepSize: stepSize,
        },
        title: {
          display: isMobile ? false : true,
          text: "Sales in " + "(" + currency + ")",
        },
        grid: {
          display: false,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
    barThickness: 4,
    borderRadius: 8,
  };

  const labels = label.slice(0, -1);

  const data = {
    labels,
    datasets: [
      {
        label: "online sales",
        data: online.slice(0, -1),
        borderColor: "#5887DE",
        backgroundColor: "#5887DE",
      },
      {
        label: "in-store sales",
        data: inStore.slice(0, -1),
        borderColor: "#a4cc47",
        backgroundColor: "#a4cc47",
      },
    ],
  };

  return (
    <>
      <Bar height={200} width={180} data={data} options={options} />
    </>
  );
};

export default BarChatDesktop;
